<template>
  <div
    class="box option has-text-centered-mobile"
    :class="{ selected : selected }"
    role="button"
    @click="onClick"
  >
    <div class="icon is-inline-block ">
      <font-awesome-icon
        :icon="iconName"
        size="2x"
      />
    </div>
    <div class="description is-padded-small is-inline-block-desktop">{{ name | capitalizeFirstLetter }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      default: 'filter'
    },
    selected: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    onClick () {
      if (this.selected) {
        this.$emit('option-deselected', this.name)
      } else {
        this.$emit('option-selected', this.name)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/colorpallet.scss";
.option {
  * {
    vertical-align: top;
  }

  .icon {
    width: 25%;
  }

  &.selected {
    color: $denim-invert;
    background-color: $denim;
  }
}
</style>
